export default __webpack_public_path__ + "static/media/dresden2.5abcac5f.png";